import { apiSlice } from "@/redux/apiSlice";
import { BudgetDataItem, BudgetLog, BudgetLogTable } from "@/types/budget";

export const DHAccountingApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getBudgetData: builder.mutation<
        BudgetDataItem[],
        {
          accounting_url: string;
          company_code: number;
          current_year: number;
          bh_type: string;
        }
      >({
        query: (params) => ({
          url: `/accounting/budget`,
          method: "POST",
          body: params,
        }),
        invalidatesTags: ["DHAccounting"],
      }),
      getBudgetLogs: builder.query<BudgetLogTable, string>({
        query: (query: string) => ({
          url: `/accounting/logs?${query.length > 0 ? query : ""}`,
          method: "GET",
        }),
        providesTags: ["DHAccounting", "Transaction", "Invoice"],
      }),
    };
  },
});

// Export the hooks
export const { useGetBudgetDataMutation, useGetBudgetLogsQuery, useLazyGetBudgetLogsQuery } =
  DHAccountingApi;

// Helper function to get unique Budkey options
export const getUniqueBudkeys = (budgetData: BudgetDataItem[]) => {
  const uniqueBudkeys = budgetData.reduce((acc, item) => {
    if (
      !acc.some(
        (bud: { value: string; label: string }) =>
          bud.value === item.budKey.toString()
      )
    ) {
      acc.push({
        value: item.budKey.toString(),
        label: `${item.budKey} - ${item.budTitle}`,
      });
    }
    return acc;
  }, [] as { value: string; label: string }[]);

  return uniqueBudkeys;
};

// Helper function to get AHKey/AHTitle options for a specific Budkey
export const getAHKeyOptionsForBudkey = (
  budgetData: BudgetDataItem[],
  budkey: number
) => {
  if (!budgetData) return [];
  return budgetData
    .filter((item) => item.budKey === budkey)
    .map((item) => ({
      value: item.AHKey.toString(),
      label: `${item.AHKey} - ${item.AHTitle}`,
      ahTitle: item.AHTitle,
    }));
};

// Helper function to get AHTitle for a specific AHKey and Budkey combination
export const getAHTitleForAHKey = (
  budgetData: BudgetDataItem[],
  budkey: number,
  ahKey: number
) => {
  const item = budgetData.find(
    (item) => item.budKey === budkey && item.AHKey === ahKey
  );
  return item ? item.AHTitle : "";
};
